import Gender from "@/models/Shared/Gender";

export default (gender: Gender) => {
    let returnVal = "Unknown"
    switch (gender) {
        case Gender.Male:
            returnVal = "Male";
            break;
        case Gender.Female:
            returnVal = "Female";
            break;
        case Gender.NonBinary:
            returnVal = "Non-binary";
            break;
        case Gender.Transgender:
            returnVal = "Transgender";
            break;
        case Gender.Intersex:
            returnVal = "Intersex";
            break;
        case Gender.PreferNotToSay:
            returnVal = "Prefer not to say";
            break;
    }
    return returnVal;
} 